/* eslint-disable max-len */

import cn from 'classnames';
import { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CareerBlock from '../../components/CareerBlock/CareerBlock';
import Divisions from '../../components/Divisions';
import { FeaturesBlock } from '../../components/FeaturesBlock';
import MainHeader from '../../components/MainHeader';
import MainHeroBlock from '../../components/MainHeroBlock';
import MainIdeaBlock from '../../components/MainIdeaBlock';
import MainPageFooter from '../../components/MainPageFooter';
import MediaBlock from '../../components/MediaBlock';
import ScrollToTop from '../../components/ScrollToTop';
import VideoBlock from '../../components/VideoBlock';
import { requestGetNews, requestMainPage } from '../../redux/actions/main-page';
import { RootState } from '../../redux/reducers/rootReducer';
import { getNewsTabs } from '../../utils/constants/getNewsTabs';
import { SEO } from '../../utils/constants/seo';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import { IMainPage } from '../../utils/types/state-types';
import { useDocumentSeo } from '../../utils/useDocumentSeo';
import classes from './main-page.module.scss';

function MainPage() {
  const isMobileSearchOpen = useSelector<RootState, boolean | undefined>(
    (state) => state.mainReducer.isSearchOpen,
  );

  const mainPage = useSelector<RootState, IMainPage | null>(
    (state) => state.mainReducer.mainPage,
  );

  const isLoading = useSelector<RootState, boolean>(
    (state) => state.mainReducer.isLoading,
  );

  const isMobile = useMediaQuery(mediaQueries.mobile);

  const bgImage = useMemo(() => {
    if (isMobile) {
      return mainPage?.startBlockTechImage;
    }
    return mainPage?.startBlockForDesktopImage;
  }, [isMobile, mainPage?.startBlockForDesktopImage]);

  const dispatch = useDispatch();

  const news = useSelector<RootState, any>(
    (state) => state.newsReducer.responses,
  );

  const dispath = useDispatch();
  useEffect(() => {
    dispath(
      requestGetNews({ division: getNewsTabs('null'), mode: 'divisionPage' }),
    );
  }, []);

  useDocumentSeo(SEO.mainPage);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!mainPage) {
      dispatch(requestMainPage());
    }
  }, [mainPage]);

  return (
    <div
      className={cn(classes.mainPageContainer, {
        [classes.hiddenMainPage]: isMobileSearchOpen,
      })}
    >
      <ScrollToTop showPosition={820} />
      <MainHeader />
      <MainHeroBlock bgImage={bgImage} />
      <MainIdeaBlock />
      <CareerBlock title={mainPage ? mainPage.scrollCardsTitle : ''} />
      <Divisions />
      {mainPage?.featuresShow && (
        <FeaturesBlock
          title={mainPage?.featuresTitle || ''}
          cards={mainPage ? mainPage?.featuresCards : null}
          buttonText={mainPage?.featuresButtonText || 'Смотреть все вакансии'}
        />
      )}

      <VideoBlock
        videoBlockShow={!!mainPage?.videoBlockShow}
        videoLink={mainPage?.videoLink}
        videoBlockTitle={mainPage?.videoTitle || ''}
        videoDescription={mainPage?.videoDescription || ''}
        videoTag={mainPage?.videoTag || ''}
      />

      {mainPage?.newsBlockShow && news.length !== 0 ? (
        <MediaBlock news={news} title="Почитай про нас" />
      ) : null}
      <MainPageFooter isLoadingContent={isLoading} />
    </div>
  );
}

export default memo(MainPage);
